// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--account--home.json";
import part1 from "./en/src--account--lists.json";
import part2 from "./en/src--account--orders.json";
import part3 from "./en/src--account--personal-info.json";
import part4 from "./en/src--account--warranties.json";
import part5 from "./en/src--account.json";
import part6 from "./en/src--login.json";
import part7 from "./en/src--marketing--unsubscribe.json";
import part8 from "./en/src--mobile-upload.json";
import part9 from "./en/src--order--hooks.json";
import part10 from "./en/src--order--order-edit.json";
import part11 from "./en/src--order--order-tracking--fulfillment.json";
import part12 from "./en/src--order--recycling.json";
import part13 from "./en/src--order--return-flow--review.json";
import part14 from "./en/src--order-tracking-iframes.json";
import part15 from "./en/src--order.json";
import part16 from "./en/src--return.json";
import part17 from "./en/src--utils.json";
import part18 from "./en/src--warranties--policies.json";
import part19 from "./en/src--warranties.json";
import part20 from "./en/src--withdrawal.json";
import part21 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
);
